function removeDiacritics(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '_').toLowerCase();
}


if($('.id--16').length){  
  document.addEventListener('shoptet.checkoutShared.modalMagic', function () {
    let totalWeight = 0;
    const cartItems = getShoptetDataLayer().cartInfo.cartItems;
    cartItems.forEach(item => {
        totalWeight += item.weight * item.quantity;
    });

    $('.branch-picker-wrapper .branch-saved').removeClass('noPossible');
    $('.not').remove()
    $('.branch-information table tr th').each(function() {
        if ($(this).text().match('Partner')) {
            const partnerText = $(this).closest('tr').find('td').text();
            if (partnerText.toLowerCase().includes('box')) {
                $(this).closest('form').find('.branch-picker-wrapper .branch-saved').addClass('noPossible');
                $(this).closest('form').find('.branch-picker-wrapper').after('<div class="not">'+hlaska+'</div>');
            }
        }
    });
  
  })

  



    document.addEventListener('shoptet.modal.resize', function () {
      let totalWeight = 0;
      const cartItems = getShoptetDataLayer().cartInfo.cartItems;
      cartItems.forEach(item => {
          totalWeight += item.weight * item.quantity;
      });
  
      $('.cpost-delivery-point-result-table tr').each(function() {
        if ($(this).find('td strong').text().toLowerCase().includes('box')) {
            const zipCodeText = $(this).text();
            const closestTr = $(this).closest('tr');
           closestTr.addClass('notAvaibleBox').append('<div class="not">'+hlaska+'</div>');
        }
      });
  });

}